import { render, staticRenderFns } from "./editResponsibleDialog.vue?vue&type=template&id=02029d0b"
import script from "./editResponsibleDialog.vue?vue&type=script&lang=ts"
export * from "./editResponsibleDialog.vue?vue&type=script&lang=ts"
import style0 from "@/components/acquisitionList/ui/acquisitionViews.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "@/components/common/modern/modern.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "@/components/common/modern/modernDialog.css?vue&type=style&index=2&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports